import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import ShopIsClosedModal from '@conversion/containers/ShopIsClosedModal';
import { getShopDetailsProductConfigurationRoute } from '@services/routes.service';
import { pick } from '@utils/object';
import { canOrder } from '@utils/shop';
import { QUERY_PARAM } from '@commons/constants';

// Do not add price, because it could have discounts.
export const getProductCardProps = product =>
  pick(product, [
    'id',
    'name',
    'image',
    'description',
    'itemId',
    'isFavourite',
    'subsidizedProduct',
    'price',
    'discount',
  ]);

export class ProductCardContainer extends React.PureComponent {
  state = { showShopIsClosedModal: false };

  showShopIsClosedModal = () => this.setState({ showShopIsClosedModal: true });

  hideShopIsClosedModal = () => this.setState({ showShopIsClosedModal: false });

  goToProductConfig(menuSection) {
    const {
      id,
      shopUrl,
      pushPage,
      shop,
      setShop,
      match: {
        params: { city, restaurant },
      },
      query,
      fromShopList,
    } = this.props;

    const { SEARCH, MENU_SECTION, PRODUCT_CONFIG } = QUERY_PARAM;

    if (fromShopList) setShop({ ...shop, url: shopUrl });

    const searchParam = query ? `&${SEARCH}=${query}` : '';
    const sectionParam = menuSection ? `&${MENU_SECTION}=${menuSection}` : '';

    const productConfigurationState = {
      pathname:
        shopUrl ||
        getShopDetailsProductConfigurationRoute({
          productId: id,
          city,
          restaurant,
        }),
      state: {
        product: getProductCardProps(this.props),
        redirect: Boolean(fromShopList),
      },
      search: `${PRODUCT_CONFIG}=${id}${searchParam}${sectionParam}`,
    };

    pushPage(productConfigurationState);
  }

  onClick = async (product, clickLocation, menuSection) => {
    const {
      fromShopList,
      shop,
      onBeforeProductConfig,
      trackProductClicked,
    } = this.props;
    const { success, error } = await onBeforeProductConfig();

    if (!fromShopList)
      trackProductClicked({ product, clickLocation, menuSection });

    if (success) {
      if (shop && !canOrder(shop)) {
        this.showShopIsClosedModal();
      } else {
        this.goToProductConfig(menuSection);
      }
    } else if (error) {
      this.showShopIsClosedModal();
    }
  };

  render() {
    const { children } = this.props;
    const { showShopIsClosedModal } = this.state;
    return (
      <>
        {children(this.onClick)}
        {showShopIsClosedModal && (
          <ShopIsClosedModal open onClick={this.hideShopIsClosedModal} />
        )}
      </>
    );
  }
}

ProductCardContainer.defaultProps = {
  fromShopList: false,
  onBeforeProductConfig: () => ({ success: true }),
};

ProductCardContainer.propTypes = {
  // calling component
  id: PropTypes.number.isRequired,
  shopUrl: PropTypes.string,
  children: PropTypes.func.isRequired,
  fromShopList: PropTypes.bool,
  query: PropTypes.string,
  onBeforeProductConfig: PropTypes.func,

  // redux
  shop: PropTypes.shape({
    opened: PropTypes.number.isRequired,
    acceptsPreOrder: PropTypes.bool.isRequired,
  }),
  pushPage: PropTypes.func.isRequired,
  setShop: PropTypes.func.isRequired,
  trackProductClicked: PropTypes.func.isRequired,

  // withRouter
  match: PropTypes.shape({
    params: PropTypes.shape({
      city: PropTypes.string,
      restaurant: PropTypes.string,
    }),
  }).isRequired,
};

export default withRouter(ProductCardContainer);
